var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2394",
    "data-name": "Rectangle 2394",
    width: 38,
    height: 38,
    rx: 5,
    transform: "translate(0.25)",
    fill: "#fff1d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telegram",
    transform: "translate(-0.25)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telegram-2",
    "data-name": "telegram",
    transform: "translate(0.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5204",
    "data-name": "Path 5204",
    d: "M28.87,38.493H9.623A9.624,9.624,0,0,1,0,28.87V9.623A9.624,9.624,0,0,1,9.623,0H28.87a9.623,9.623,0,0,1,9.623,9.623V28.87a9.623,9.623,0,0,1-9.623,9.623",
    transform: "translate(0 0)",
    fill: "#199bdf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5205",
    "data-name": "Path 5205",
    d: "M18.082,10.826H28.931a5.413,5.413,0,0,0,.555-10.8C29.3.017,29.118,0,28.931,0H9.644A9.634,9.634,0,0,0,0,9.623V28.87A18.063,18.063,0,0,1,18.081,10.826",
    transform: "translate(0 0)",
    fill: "#32b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5206",
    "data-name": "Path 5206",
    d: "M39.959,24.873A9.625,9.625,0,1,0,49.417,34.5V15.25a9.542,9.542,0,0,1-9.459,9.623",
    transform: "translate(-10.924 -5.627)",
    fill: "#0082be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5207",
    "data-name": "Path 5207",
    d: "M29.68,16.154a1.749,1.749,0,0,1,1.772.249A1.82,1.82,0,0,1,32.11,18.1c-.689,4.558-1.952,12.912-2.623,17.345a1.8,1.8,0,0,1-1.076,1.393,1.748,1.748,0,0,1-1.729-.215l-7.734-5.8a1.216,1.216,0,0,1-.11-1.843l7.217-6.934a.3.3,0,0,0,.029-.4.292.292,0,0,0-.393-.066l-9.541,6.33a3.5,3.5,0,0,1-2.8.478L8.876,27.245a1.209,1.209,0,0,1-.165-2.279L29.68,16.154Z",
    transform: "translate(-3.03 -5.91)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8ee5d365297403c1bc649f9ab23eac4c.svg";
export { ForwardRef as ReactComponent };